import Scrollbars from "react-custom-scrollbars";
import styles from "./MikeMessagesScrollbars.module.less";
import { CopilotMessageContext } from "~/providers/CopilotMessageProvider";
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";
import {
  getCopilotMessageHTMLElements,
  setElementMikeVisible,
} from "../../helpers/copilotMessageElement";
import { setScrollByMikeId } from "~/pages/copilotMessage/helpers/copilotMessageElement";
import { useUserLogContext } from "~/providers/UserLogProvider";
import { CopilotLogsType } from "~/pages/copilotMessage/types/copilotLogs";

interface MikeMessagesScrollbarsProps {
  children?: React.ReactNode;
}

function MikeMessagesScrollbars({ children }: MikeMessagesScrollbarsProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const scrollByMikeIdRef = useRef<() => void>();

  const {
    historyLoading,
    requestLoading,
    selectedConversation,
    canDisplayPreviosMessageButton,
  } = useContext(CopilotMessageContext);

  const { insertUserLog, isProgramaticScrolling } = useUserLogContext();

  const checkVisible = useCallback(() => {
    if (wrapperRef.current === null) return;

    const mikeItems = getCopilotMessageHTMLElements();
    const wrapperEl = wrapperRef.current;

    mikeItems.forEach((item) => {
      const visibleStart = wrapperEl.parentElement?.scrollTop ?? 0;
      const visibleEnd =
        (wrapperEl.parentElement?.scrollTop ?? 0) +
        (wrapperEl.parentElement?.offsetHeight ?? 0);

      const itemTop = item.element.offsetTop;
      const itemBottom = item.element.offsetTop + item.element.offsetHeight;

      const visible =
        (itemTop >= visibleStart && itemTop <= visibleEnd) ||
        (itemBottom >= visibleStart && itemBottom <= visibleEnd);

      setElementMikeVisible(item.element, visible);
    });

    if (!isProgramaticScrolling.current) {
      insertUserLog(CopilotLogsType.Scrolled);
    }
    isProgramaticScrolling.current = false;
  }, [insertUserLog, isProgramaticScrolling]);

  useEffect(() => {
    if (!requestLoading) {
      scrollByMikeIdRef.current = setScrollByMikeId(
        undefined,
        isProgramaticScrolling,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestLoading]);

  useEffect(() => {
    if (!historyLoading && canDisplayPreviosMessageButton) {
      checkVisible();
    }
  }, [historyLoading, canDisplayPreviosMessageButton, checkVisible]);

  useEffect(() => {
    return () => {
      isProgramaticScrolling.current = true;
      scrollByMikeIdRef.current?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    //INFO: Fatih,
    //After second scroll programaically, x axis scrollbar apperance.
    //This code is for hiding x axis scrollbar.
    const scrollDiv = document.querySelector(
      "#mikeMessagesScrollbars > div:nth-child(1)",
    ) as HTMLDivElement;
    if (scrollDiv) scrollDiv.style.overflowX = "hidden";
    return () => {};
  }, []);

  return (
    <Scrollbars
      className={styles.MikeMessagesScrollbars}
      autoHide
      onScrollStop={checkVisible}
      id="mikeMessagesScrollbars"
    >
      <div
        id="mikeMessagesScrollWrapper"
        key={selectedConversation?.id}
        className={styles.wrapper}
        ref={wrapperRef}
      >
        {children}
      </div>
    </Scrollbars>
  );
}

export default MikeMessagesScrollbars;
